import React from 'react';

export interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  onClick: (e: React.MouseEvent<unknown>) => void | Promise<any>;
  children?: React.ReactNode;
  busyContent?: React.ReactNode;
  busyText?: React.ReactNode;
  isIdle?: boolean;
  disabled?: boolean;
  className?: string;
  type?: 'submit' | 'button';
}

export default React.forwardRef(function StateButton(
  {
    children,
    onClick,
    busyContent,
    busyText,
    isIdle = true,
    disabled = false,
    className = 'btn-primary',
    type = 'button',
    ...other
  }: Props,
  ref: React.ForwardedRef<HTMLButtonElement>
): JSX.Element {
  const [isLoading, setIsLoading] = React.useState(false);
  const mountedRef = React.useRef(true);

  React.useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  });

  React.useEffect(() => {
    if (isIdle !== !isLoading) {
      setIsLoading(!isIdle);
    }
  }, [isIdle]);

  const setLoadingFalse = () => {
    if (mountedRef.current) {
      setIsLoading(false);
    }
  };

  const handleClick = (e: React.MouseEvent<unknown>) => {
    const promise = onClick(e);

    if (
      promise !== undefined &&
      'then' in promise &&
      promise.then !== undefined
    ) {
      setIsLoading(true);
      promise.then(setLoadingFalse, setLoadingFalse);
    }
  };

  return (
    <button
      ref={ref}
      className={`btn ${className || ''}`}
      onClick={handleClick}
      disabled={disabled || isLoading}
      type={type}
      {...other}
    >
      {!isLoading ? (
        children
      ) : busyContent !== undefined ? (
        busyContent
      ) : (
        <span>
          <i className="fa fa-circle-notch fa-spin" /> {busyText}
        </span>
      )}
    </button>
  );
});
